import { render, staticRenderFns } from "./AccessUserConf.vue?vue&type=template&id=008e3f47&"
import script from "./AccessUserConf.vue?vue&type=script&lang=js&"
export * from "./AccessUserConf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports